<template>
  <v-card
    class="stats-bar"
    elevation="2"
    rounded
    color="surface"
    :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'"
  >
    <div class="d-flex justify-space-between px-10">
      <div class="text-center">
        <div class="stat-label">{{ lastTTLLabel }}</div>
        <div class="stat-value">{{ total }}</div>
      </div>
      <div class="text-center">
        <div class="stat-label">{{ $t("avgRate") }}</div>
        <div class="stat-value">
          {{ averageMessageRate.toFixed(1) }} {{ $t("perMinute") }}
        </div>
      </div>
      <div class="text-center">
        <div class="stat-label">{{ $t("uniqueTypes") }}</div>
        <div class="stat-value">{{ uniqueTypes }}</div>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "StatsBar",
  props: {
    total: { type: Number, required: true },
    uniqueTypes: { type: Number, required: true },
    uniqueStatuses: { type: Number, required: true },
    averageMessageRate: { type: Number, default: 0 },
  },
  computed: {
    ...mapGetters(["uiTtlMinutes"]),
    lastTTLLabel() {
      return this.$t("lastXMinutes").replace("{minutes}", this.uiTtlMinutes);
    },
  },
};
</script>
<style scoped>
.stats-bar {
  background: none;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 18px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.stat-label {
  font-size: 1em;
  color: var(--v-theme-secondary);
  font-weight: 500;
}
.stat-value {
  font-size: 1.3em;
  font-weight: bold;
  color: var(--v-theme-primary);
}
@media (max-width: 768px) {
  .stats-bar {
    width: 100%;
    max-width: 100%;
    padding: 0.5em 0.2em;
    margin-bottom: 1em;
  }
  .stat-label {
    font-size: 70%;
  }
  .stat-value {
    font-size: 70%;
  }
}
</style>
